import { alpha, Box, colors, InputBase, Popover, styled, SxProps, Tabs, TextField, Toolbar, Typography, useTheme } from "@mui/material";
import { StyleguideSavioColors, StyleguideSavioFonts } from "../../configuration/themeSettings";


export const SearchContainer = styled("div", {
    label: "homePage_SearchBar-search-container",
})(({ theme }) => ({
    //width: "40%",
    marginTop: 17,

    "+ .MuiBox-root": {
        marginTop: 15,
        minHeight: 21,

        "> div": {
            marginLeft: 0,
        }
    }
}));





export const StyleTypographyButton = styled(Typography, {
    label: "search-inputcontent",
})<SearchProps>(({ context, theme }) => ({
    fontSize: 14,
    fontWeight:
        context == "search"
            ? StyleguideSavioFonts.bold
            : StyleguideSavioFonts.medium,
    color: StyleguideSavioColors.mainBlue,
    textTransform: context == "search" ? "uppercase" : "none",
    textAlign: "left",
   
}));

interface SearchProps {
    context?: string;
}


export const Search = styled("div", {
    label: "search-inputcontent_search",
})<SearchProps>(({ context, theme }) => ({
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 1),
    "&:hover": {
        backgroundColor: alpha(theme.palette.common.white, 1),
    },
    marginRight: "auto",
    marginLeft: "auto",
    width: context === 'search' ? 300 : 500,
    height: "auto",
    alignContent: "center",
   
}));

export const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    left: 0,
    top: 0,
    // color: theme.palette.primary.main,
}));

export const CloseIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    right: -15,
    top: 15,
    color: theme.palette.primary.main,
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
    marginRight: 56,
    display: "block",
    "& .MuiInputBase-input": {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: theme.spacing(5),
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("md")]: {
            width: "20ch",
        },
    },
}));

export const Menu = styled("div", { label: "MenuLocationAndEquipment" })
    (({ theme }) => ({
        // backgroundColor: theme.palette.footer.main,
    }));

export const PopoverStyled = styled(Popover, { label: "PopoverStyled" })
    <SearchProps>(({ context, theme }) => ({
        "> .MuiPopover-paper": {

            width: context === 'search' ? 350 : 500,
            height: 'calc(100vh - 300px)',
            borderBottomRightRadius: '4px !important',
            borderBottomLeftRadius: '4px !important',
            "> .MuiBox-root": {
                height: '100%',
                position: 'relative',
                "header + .MuiBox-root ": {
                    height: 'calc(100% - 95px)',
                    overflow: 'hidden',
                    overflowY: 'auto',
                },
                "header + .MuiBox-root  + .MuiBox-root": {
                    height: 'calc(100% - 94px)',
                    overflow: 'hidden',
                    overflowY: 'auto',
                }
            }
        }
    }));
export const ToolbarStyled = styled(Toolbar, { label: "ToolbarStyled" })
    (({ theme }) => ({
        height: 55,
        minHeight: "auto !important",
        padding: "0 !important",
    }));
export const SearchField = styled(TextField, { label: "SearchField" })
    (({ theme }) => ({

        'input':{
            fontSize: 14,
        },
        "button": {
            color: StyleguideSavioColors.text.black + " !important",
        }
    }));

export const TabsSearch = styled(Tabs, { label: "TabsSearch" })(({ theme }) => ({
    position: "relative",
    minHeight: 35,
    "::after": {
        //content: "'/'",
        position: "absolute",
        fontSize: 37,
        left: "calc(50% - 4px)",
        top: 0,
    },
    ".MuiTab-root": {
        color: StyleguideSavioColors.text.grayTitles,
        backgroundColor: "#fff",
        height: 35,
        minHeight: 35,

        transition: theme.transitions.create("opacity"),
        "&.Mui-disabled": {
            color: StyleguideSavioColors.lightGrey,
        },
        "&.Mui-selected": {
            backgroundColor: "#fff",
            color: StyleguideSavioColors.blue,
        },

        "&:not(.Mui-selected):hover": {
            color: StyleguideSavioColors.blue,
        },

        svg: {
            marginTop: -3,
        },
    },
}));


export const useClasses = () => {
    const theme = useTheme();

    const classes = {
        noWrap: {
            overflow: "hidden",
            whiteSpace: "nowrap",
            // color: theme.palette.grey,
            // backgroundColor: theme.palette.grey,
            fontSize: 14,
        },

        buttonSearch: {
            // backgroundColor: theme.palette.grey,
            justifyContent: "start",
            textTransform: "none",
            padding: "8px",
            height: 55,

            ".MuiButton-startIcon": {
                marginLeft: 1,
            },
        },

        appBar: {
            backgroundColor: theme.palette.common.white,
            flex: "0 0 50px",
            boxShadow: "none",
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
            borderBottomColor: theme.palette.footer.dark,
        },

        icon: {
            color: "red",
        },

        textFieldInput: {
            backgroundColor: theme.palette.common.white,
            color: theme.palette.common.white,
            padding: "22px 12px 10px",
        },

        fieldInputToolBar: {
            backgroundColor: theme.palette.common.white + " !important",
        },

        adornedEnd: {
            backgroundColor: theme.palette.common.white + " !important",
            color: theme.palette.common.white,
            paddingRight: "0px",
        },

        tabRoot: {

            flexGrow: 1,
            flex: 1,
            // minWidth: "500px"
            // maxWidth: 500,
        },

        notActive: {
            backgroundColor: StyleguideSavioColors.disabledBlue,
            color: StyleguideSavioColors.grey + " !important",
        },

        active: {
            color: StyleguideSavioColors.text.black,
            backgroundColor: StyleguideSavioColors.mainBlue,
        },

        listItem: {
            borderBottomStyle: "solid",
            borderBottomWidth: "1px",
            borderBottomColor: theme.palette.grey, //   '1px solid lightgrey !important'
            paddingTop: "0px",
            paddingBottom: "0px",
            cursor: "pointer",
            "&:hover": {
                backgroundColor: alpha(theme.palette.footer.main, 0.2),
            },
            "& p": { textTransform: "uppercase" },
            "& disabled": { color: "red" },
        },

        listItemTextSecondary: {
            overflow: "hidden",
            whiteSpace: "wrap",
            display: "flex",
            maxWidth: 500,
            textOverflow: "ellipsis",
            color: StyleguideSavioColors.text.black,
        },

        searchTextBox: {
            alignItems: "center",
            width: "100%",
            height: "100%",
            justifyContent: "center",
        },

        container: {
            height: "calc(100% - 115px)",
        },
    };
    return classes;
};